// routes
import { PATH_DASHBOARD, PATH_PRIVATE } from 'routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API_KEY || '';

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.app; // as '/dashboard/app'

export const PATH_HOME_PRIVATE = PATH_PRIVATE.demandes.list;

export const BASIC_AUTH = 'T0F1dGgyV2ViVXNlcjpzZWNyZXQ=';
// LAYOUT
// ----------------------------------------------------------------------
export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32
};

export const NAVBAR = {
  BASE_WIDTH: 300,
  DASHBOARD_WIDTH: 350,
  DASHBOARD_COLLAPSE_WIDTH: 0,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 45,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20
};

// ROLES
// ----------------------------------------------------------------------
export const ROLES = {
  ADMIN: 'A4L_ADMINISTRATOR',
  ESTABLISHMENT: 'ESTABLISHMENT_ADMINISTRATOR'
};

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeColorPresets: 'default',
  themeLayout: 'horizontal',
  themeStretch: false,
};

